<template>
  <el-select v-model="value"  :disabled="disable"  :remote-method="remoteMethod" @clear="clearFn" @visible-change="visibleChange">
    <div ref="divv">
      <el-option
        v-for="item in itemList"
        :key="item.value"
        :label="item.label"
        :value="item.value"
        :disabled="item.isDeleted && (value === item.value || (Array.isArray(value) && value.indexOf(item.value) < 0))"
      >
      </el-option>
    </div>
  </el-select>
</template>

<script>

export default {
  name: 'HSelect',
  emits: ['update:modelValue', 'update:pageObj'],
  props: {
    fieldDetail: {
      type: Object,
      default: () => ({})
    },
    disable: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: [Array, Number, String, Object]
    },
    itemList: {
      type: Array,
      default: () => []
    },
    pageObj: {
      type: Object
    }
  },
  data () {
    return {
      loading: false,
      keywords: '',
    }
  },
  computed: {
    value: {
      get () {
        return this.modelValue
      },
      set (val) {
        this.$emit('update:modelValue', val)
      }
    }
  },
  mounted () {
    const scrollDom = this.$refs.divv?.parentNode.parentNode
    if (scrollDom) {
      scrollDom.addEventListener('scroll', () => {
        const { scrollTop, scrollHeight, clientHeight } = scrollDom
        if (scrollHeight - Math.ceil(scrollTop) <= clientHeight) {
          this.loadMore()
        }
      })
    }
  },
  methods: {
    loadMore () {
      this.$nextTick(() => {
        // console.log('测试', this.fieldDetail.options.next, this.pageObj.pageNumber + 1, Math.floor(this.fieldDetail.options.count / this.pageObj.pageSize))
        if (this.fieldDetail.options.next) {
          this.updatePageData(this.pageObj.pageNumber + 1)
        }
      })
    },
    remoteMethod (e) {
      this.keywords = e
      this.updatePageData(1)
    },
    updatePageData (pageNumber) {
      this.$emit('update:pageObj',
        {
          pageSize: this.pageObj.pageSize,
          pageNumber: pageNumber,
          id: this.fieldDetail.options.valueList.labelSet,
          key: this.fieldDetail.key,
          keyword: this.keywords
        }
      )
    },
    visibleChange (e) {
      // console.log(e)
    },
    clearFn () {
      if (this.fieldDetail.options.remote) {
        this.keywords = ''
        this.updatePageData(1)
      }
    }
  }
}
</script>

<style scoped>

</style>
